import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard, RoleBasedGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------
const OverviewAppPage = lazy(() => import('src/pages/dashboard/height-student-dashboard'));

// DOWNLOADS & ADMIT CARD
const StudentHEIGHTDownloadsPage = lazy(() => import('src/pages/dashboard/height-student/downloads'));
const StudentHEIGHTAdmitCardPage = lazy(() => import('src/pages/dashboard/height-student/admit-card'));

// STUDENT EXAMINATION
const StudentHEIGHTExaminationListPage = lazy(() => import('src/pages/dashboard/HEIGHT-tests/list'));
// EXAM RESULTS 
const StudentHEIGHTExaminationResultListPage = lazy(() => import('src/pages/dashboard/HEIGHT-test-results/list'));
const HEIGHTTestResultProfilePage = lazy(() => import('src/pages/dashboard/HEIGHT-test-results/profile'));

// ----------------------------------------------------------------------

export const heightstudentdashboardRoutes = [
  {
    path: 'heightstudentdashboard',
    element: (
      <AuthGuard>
        <RoleBasedGuard roles={['admin', 'height_student']} hasContent>
          <DashboardLayout>
            <Suspense fallback={<LoadingScreen />}>
              <Outlet />
            </Suspense>
          </DashboardLayout>
        </RoleBasedGuard>
      </AuthGuard>
    ),
    children: [
      { element: <OverviewAppPage />, index: true },
      { path: 'downloads', element: <StudentHEIGHTDownloadsPage /> },
      { path: 'admitcard', element: <StudentHEIGHTAdmitCardPage /> },

      {
        path: 'studentexamination',
        children: [
          { element: <StudentHEIGHTExaminationListPage />, index: true },
        ],
      },
      {
        path: 'examinationresult',
        children: [
          { element: <StudentHEIGHTExaminationResultListPage />, index: true },
          { path: ':id/profile', element: <HEIGHTTestResultProfilePage /> },
        ],
      },
    ],
  },
];
